import type { DocTreeNode } from '@/models/api-generated'
import { ref } from 'vue'

export const folderRefreshCallback = ref<Function>()
export const historyRefreshCallback = ref<Function>()

export const selectedFolder = ref<DocTreeNode>()
export const isEditingAny = ref(false)
